// $(document).ready(function() {
import "bootstrap/js/dist/modal";
require("../autoNumeric-min");

window.mobilecheck = function () {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

// == navigation == //
var flipper = {
  init: function () {
    flipper.vars = {
      $flip: $(".flip"),
      $flipLink: $(".flip-link"),
      cardClass: ".card",
      flippedClass: "flipped",
    };
    flipper.bindEvents();
  },
  bindEvents: function () {
    flipper.vars.$flipLink.on("click", function (e) {
      flipper.flipCard(flipper.vars.$flip);
      e.preventDefault();
    });
    flipper.vars.$flip.on("click", function (e) {
      flipper.flipCard($(this));
      e.preventDefault();
    });
  },
  flipCard: function (el) {
    var $card = el.find(flipper.vars.cardClass);
    if ($card.hasClass(flipper.vars.flippedClass))
      $card.removeClass(flipper.vars.flippedClass);
    else $card.addClass(flipper.vars.flippedClass);
  },
};

// == navigation == //
var redeem = {
  init: function () {
    redeem.vars = {
      // window width
      isDesktop: window.mobilecheck,
      isOldIE:
        $("html").hasClass("ie6") ||
        $("html").hasClass("ie7") ||
        $("html").hasClass("ie8"),

      // form
      $formSm: $("#redeem_form_sm"),
      $formLg: $("#redeem_form_lg"),
      $locationIdSm: $("#certificate_redeemed_location_id_sm"),
      $locationIdLg: $("#certificate_redeemed_location_id_lg"),
      $faceSm: $("#certificate_face_sm"),
      $faceLg: $("#certificate_face_lg"),
      $redeemBtn: $(".btn-mark-as-redeemed"),
      $cancelBtn: $(".btn-cancel-redeem"),

      $printBtn: $(".btn-mark-as-printed"),

      // gift card
      $merchantName: $(".merchant-name"),
      $merchantNameWithAddress: $(".merchant-name-with-address"),
      $merchantAddress: $(".merchant-address"),
      $faceValue: $(".face-value"),

      // modal
      $faceSelect: $("#certificate_face_select"), // deprecated
      $faceInput: $("#certificate_face"),
      locationIdSelectId: "#certificate_redeemed_location_id_select",
      $locationIdSelect: $("#certificate_redeemed_location_id_select"),
      $modal: $("#redeem-modal"),
      $btnPrimary: $("#redeem-modal").find(".btn-primary"),

      // backdrop
      $backdropMsgDiv: $("#backdrop-message"),
      $backdropMsg: $("#backdrop-message").children("span#msg"),
      $backdropSuccess: $("#backdrop-success"),
      $backdropCancel: $("#backdrop-cancel"),
    };
    redeem.redeemModalChecker();
    redeem.bindEvents();
  },

  // count the number of locations in the
  // modal select list.
  numLocationsInSelect: function () {
    var num_locations_to_choose = 0;
    $(redeem.vars.locationIdSelectId + " option").each(function () {
      if ($(this).val().length > 0) num_locations_to_choose += 1;
    });
    return num_locations_to_choose;
  },

  // makes sure that a location exists
  // in the 'mark as redeemed' forms
  // if not, pops the gift card modal
  redeemModalChecker: function () {
    if (redeem.vars.$formSm.length > 0) {
      // form exists

      // bust out early if desktop view
      //if (redeem.vars.isDesktop || redeem.vars.isOldIE)
      //  return

      // if the location hidden input is present, and null, pop the modal
      if (
        redeem.vars.$locationIdSm.length &&
        redeem.vars.$locationIdSm.val().length == 0
      ) {
        // location is not saved in the form yet
        redeem.vars.$modal.modal({ backdrop: "static" });
      }

      // if the face hidden input is present, and null, pop the modal
      if (redeem.vars.$faceSm.length && redeem.vars.$faceSm.val().length == 0)
        redeem.vars.$modal.modal({ backdrop: "static" });
    }
  },

  // validates that the gift card modal
  // is good to go
  validateModal: function (el) {
    var cleanLoc = true,
      cleanFace = true;

    // location id
    // only if location select is present
    if (redeem.vars.$locationIdSelect.length > 0) {
      var $loc = $(redeem.vars.$locationIdSelect);
      if ($loc.val() > 0) {
        $loc.closest(".form-group").removeClass("has-error");
        $loc.closest(".form-group").find(".help-block").hide();
      } else {
        cleanLoc = false;
        $loc.closest(".form-group").addClass("has-error");
        $loc.closest(".form-group").find(".help-block").show();
      }
    }

    // face
    // only if input is present
    if (redeem.vars.$faceInput.length > 0) {
      var face = parseFloat(redeem.vars.$faceInput.val());
      var max = redeem.vars.$faceInput.attr("max");
      var min = redeem.vars.$faceInput.attr("min");
      cleanFace = cleanFace && !isNaN(face); // is a number
      cleanFace = cleanFace && face >= min;
      cleanFace = cleanFace && face <= max;
    }

    if (cleanFace) {
      redeem.vars.$faceInput.closest(".form-group").removeClass("has-error");
    } else {
      redeem.vars.$faceInput.closest(".form-group").addClass("has-error");
    }

    return cleanLoc && cleanFace;
  },

  showBackdrop: function (div, msg, location) {
    div.show();
    redeem.vars.$backdropMsg.html(msg);
    redeem.vars.$backdropMsgDiv.show();
    if (location) {
      $("#location-message-container").show();
      $("#location-message").html(location);
    }
  },

  bindEvents: function () {
    // on 'Mark as Printed' button
    redeem.vars.$printBtn.on("click", function (e) {
      /*
        e.preventDefault();
        var $form = $(this).closest('form');
        var msg = "Only continue if you have successfully printed the gift card."
        if (confirm(msg)) {
          $(this).submit();
        }
        */
    }),
      // on 'Show Gift Card' click
      redeem.vars.$btnPrimary.on("click", function (e) {
        if (redeem.validateModal()) {
          // face, only if select is visible
          if (redeem.vars.$faceInput.length > 0) {
            var face = redeem.vars.$faceInput.val();
            redeem.vars.$faceSm.val(face);
            redeem.vars.$faceLg.val(face);
            redeem.vars.$faceValue.html("$" + face);
          }

          // location, only if the select is visible
          if (redeem.vars.$locationIdSelect.length > 0) {
            var locationId = redeem.vars.$locationIdSelect.val();
            var parts = $(redeem.vars.locationIdSelectId + " option:selected")
              .text()
              .split(",");
            var html = "<strong>" + parts[0] + "</strong>";
            for (var i = 1; i < parts.length; i++) {
              html += "," + parts[i];
            }
            redeem.vars.$locationIdSm.val(locationId);
            redeem.vars.$locationIdLg.val(locationId);
            redeem.vars.$merchantName.html(html);
            redeem.vars.$merchantNameWithAddress.html(parts[0]);

            parts.shift();
            var address = parts.join(", ");

            redeem.vars.$merchantAddress.html(address);
          }

          // hide the modal
          redeem.vars.$modal.modal("hide");
        } else {
        }
      });

    // on modal hide
    redeem.vars.$modal.on("hidden.bs.modal", function () {
      redeem.redeemModalChecker(); // confirm we're good
    });

    // click mark as redeemed
    redeem.vars.$redeemBtn.on("click", function (e) {
      e.preventDefault();

      // ajax
      var $form = $(this).closest("form");
      var serializedData = $form.serialize();
      const request = $.ajax({
        url: $form.attr("action"),
        type: "put",
        data: serializedData,
      });

      // success
      request.done(function (data, textStatus, jqXHR) {
        if (data["success"] == "true") {
          $("h1#success-message").show();
          redeem.showBackdrop(
            redeem.vars.$backdropSuccess,
            data["message"],
            data["location_message"]
          );
        } else {
          redeem.showBackdrop(
            redeem.vars.$backdropCancel,
            data["message"],
            data["location_message"]
          );
        }
      });

      // fail
      request.fail(function (jqXHR, textStatus, errorThrown) {
        redeem.showBackdrop(redeem.vars.$backdropCancel, "error", errorThrown);
      });

      // either way, disable form
      request.always(function () {
        $form.find("input, select, button, textarea").prop("disabled", true);
      });
    });

    // cancel button
    redeem.vars.$cancelBtn.on("click", function (e) {
      console.log("is desktop?" + redeem.vars.isDesktop);
      if (!redeem.vars.isDesktop) {
        e.preventDefault();
        redeem.showBackdrop(
          redeem.vars.$backdropCancel,
          "This redemption has been canceled.",
          null
        );
      }
    });

    $("body").on("shown.bs.modal", function (e) {
      var vMax = Math.ceil(redeem.vars.$faceInput.val()).toFixed(2);

      $("input.certificate-face").autoNumeric("init", {
        vMin: "0.00",
        vMax: vMax,
      });
    });
  },
};
$(document).on("turbolinks:load", flipper.init);
$(document).on("turbolinks:load", redeem.init);

// });
